import { useEffect, useState } from 'react'

import { isDesktop } from 'react-device-detect'

export const useIsImToken = () => {
  const [isImToken, setIsImToken] = useState(false)

  useEffect(() => {
    if (isDesktop) return
    if (window.bitcoin) {
      setIsImToken(true)
    }
  }, [])

  return isImToken
}
